<template>
    <list-base-template
        :items='items'
        :event='event'
        :create='false'
        :errors='this.errors'
        v-on:paginate='getResults()'>

        <template v-slot:header>
            <h2 class="h4 p-2 m-0">{{ $t("translations.log_entries")}}</h2>
        </template>   

        <template v-slot:quick_filters>
            <div class="btn-filter-toggle" v-if='filter_type == "popup"'>
                <button type="button" class="btn btn-link" v-on:click='showFilter'><img src="img/icon-search.svg">
                    <span class="sr-only">Search</span>
                </button>
            </div>    
        </template>

        <template v-slot:site_select>
            
        </template>

        <template v-slot:filter>
            <inline-filter v-if='filter_type == "inline"'
                v-on:filterUpdated='getResults(1)' 
                :expanded='true' 
                :key='event' 
                ref="listFilter" 
                :modalid='modalid'></inline-filter>
            <list-filter v-else-if='filter_type == "popup"'
                v-on:apply='getResults(1)' 
                :expanded='true' 
                :key='event' 
                ref="listFilter" 
                :modalid='modalid'></list-filter>
        </template>
        
        <template v-slot:current-filter>
            <div v-if='$refs.listFilter'>
                <p v-if='$refs.listFilter && $refs.listFilter.$refs.search.value' class='search-lozenge badge badge-primary badge-pill'>
                    {{$refs.listFilter.$refs.search.value}}
                    <a v-on:click.prevent='$refs.listFilter.$refs.search.value = ""; getResults(1);' href="#">&times;</a>
                </p>
                <template v-for='(filter, index) in $refs.listFilter.appliedFilters'>
                    <p :key='index' v-if='$refs.listFilter.filterHasValue(filter)' class='search-lozenge badge badge-primary badge-pill'>
                        {{$refs.listFilter.getFilterDefinition(filter)}}
                        <a v-on:click.prevent='$refs.listFilter.appliedFilters.length > 1 ? $refs.listFilter.removeFilterByIndex(index) : $refs.listFilter.clearFilters();$refs.listFilter.applyFilters()' href="#">&times;</a>
                    </p>
                </template>
            </div>
        </template>

        <template v-slot:list>
            <ul :class='"list list-" + model'>

                <template v-for="item in items.data">
                    <router-link tag='li' :to='(subroute ? "/" + event + "-list" : "") + "/" + event + "-show/" + item.id' :key='item.id' :class='"list-" + event + "_item"'>
                        <h2 class="h6"><strong>{{item.log_name}}</strong></h2>
                        <div>{{item.description}}</div>
                        <div>{{item.created_at | formatDateTime}}</div>
                    </router-link>
                            
                </template>
            </ul>
        </template>

        <template v-slot:sort>
            
        </template>

        <template v-slot:perpage>
            
        </template>

        <template v-slot:selectedcontent>
            <router-view 
                v-on:reopen='getResults()' 
                v-on:delete='getResults()' 
                v-on:viewNext='viewNext()' 
                ref='content2' 
                name='content2' 
                :key="$route.fullPath">
            </router-view>
        </template>
    </list-base-template>
</template>

<script>
	export default {
        extends: app.base.listBase,
		props: [
		],
		data: function() {
			return {
                modalid: "logs-filter-modal",
                displayelement: "log-list",
                event: "log",
                model: "log",
                title: "log_entries",
                path: 'log',
                route: '/api/v1/logs',
                // Should be enabled for
                    // "usergroup"
                    // "feedback"
                force_na_provider_id: false,
                search_on_open: false,
                filter_type: "inline",
            };
        },
        watch: {
            
        },
		methods : {
            haveIncomingFilterParameters() {
                if(this.$route.params.subject_object_id) {
                    return true;
                }
                return false;
            },
            setFiltersFromRouteParams() {
                if(this.haveIncomingFilterParameters()) {
                    //console.warn("Setting filter:", this.$route.params.subject_object_id)
                    this.$refs.listFilter.setFilter("causer_subject_subject2_id", "=", this.$route.params.subject_object_id);
                    //this.$refs.listFilter.setFilter("causer_id", "=", this.$route.params.subject_object_id);
                    //this.$refs.listFilter.setFilter("object2_id", "=", this.$route.params.subject_object_id);
                    delete(this.$route.params.subject_object_id);
                }
            },
		}
    }
</script>
